import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6882120"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-button" }
const _hoisted_2 = { class: "change-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_move_navigation = _resolveComponent("move-navigation")!
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_drive_ui_wrapper, {
        key: 0,
        title: _ctx.title
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "flex",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMoveTo && _ctx.openMoveTo(...args)))
          }, [
            _createVNode(_component_move_navigation, {
              currentPosition: _ctx.currentPosition,
              showDots: _ctx.showDots
            }, null, 8, ["currentPosition", "showDots"]),
            _createElementVNode("button", _hoisted_1, _toDisplayString(_ctx.$localize('drive.change.location.button')), 1)
          ])
        ]),
        _: 1
      }, 8, ["title"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "flex",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openMoveTo && _ctx.openMoveTo(...args)))
      }, [
        _createVNode(_component_move_navigation, {
          currentPosition: _ctx.currentPosition,
          showDots: _ctx.showDots
        }, null, 8, ["currentPosition", "showDots"]),
        _createElementVNode("button", _hoisted_2, _toDisplayString(_ctx.$localize('drive.change.location.button')), 1)
      ]))
}